import React from 'react';
import styled, { keyframes } from 'styled-components';
import LogoOval from '../Icon/LogoOval';
import Flex from 'Components/Grid/Flex';
import { WLabel } from 'constants/enums';
import { selectByWL } from 'utils/wLabel';
import { colors } from 'constants/colors';

export const SPINNER_CONTAINER_TEST_ID = 'SPINNER_CONTAINER_TEST_ID';

const bounce = keyframes`
  from {
    transform: scale(1);
  }

  25% {
    transform: scale(0.7);
  }

  50% {
    transform: scale(1);
  }

  to {
    transform: scale(1);
  }
`;

const wlColorSpin = selectByWL({
  [WLabel.Default]: colors.darkBlueGreen,
  [WLabel.Globus]: colors.simpleOrange,
});

export const Spin = styled(LogoOval).attrs({ color: wlColorSpin })`
  &:nth-child(1) {
    animation: ${bounce} 1.2s linear 0s infinite;
  }
  &:nth-child(2) {
    animation: ${bounce} 1.2s linear 0.15s infinite;
  }
  &:nth-child(3) {
    animation: ${bounce} 1.2s linear 0.3s infinite;
  }
`;

const Spinner = () => (
  <Flex data-testid={SPINNER_CONTAINER_TEST_ID} center width="100%">
    <Spin width="14" height="14" />
    <Spin width="14" height="14" />
    <Spin width="14" height="14" />
  </Flex>
);

export default Spinner;
